import { render, staticRenderFns } from "./modifyPassword.vue?vue&type=template&id=a87196be&scoped=true&"
import script from "./modifyPassword.vue?vue&type=script&lang=js&"
export * from "./modifyPassword.vue?vue&type=script&lang=js&"
import style0 from "./modifyPassword.vue?vue&type=style&index=0&id=a87196be&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a87196be",
  null
  
)

export default component.exports